module.exports = __webpack_public_path__ + "static/media/SignUp.6d3934bd.svg";